import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCartState } from '../hooks/useCart';

const Header: React.FC = () => {
  const { cart } = useCartState();
  const cartItemCount = cart?.items.reduce((total, item) => total + item.quantity, 0) ?? 0;

  return (
    <header
      className="sticky top-0 z-50 shadow-lg border-b"
      style={{
        backgroundColor: '#0f0f0f',
        borderImage: 'linear-gradient(90deg, #39ff14, #ff69b4, #bf00ff) 1',
        borderBottom: '2px solid',
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo - Home Link */}
          <Link to="/" className="flex items-center transition-opacity hover:opacity-80 cursor-pointer">
            <img 
              src="/logo.png" 
              alt="NHLFAN90" 
              className="h-10 w-auto pointer-events-none select-none"
              draggable={false}
              style={{ filter: 'drop-shadow(0 0 8px rgba(57, 255, 20, 0.3))' }}
            />
          </Link>

          {/* Cart */}
          <Link
            to="/cart"
            className="relative flex items-center space-x-1 px-3 py-2 rounded-md text-sm font-medium transition-colors hover:bg-opacity-10 cursor-pointer"
            style={{ color: '#ffffff' }}
          >
            <ShoppingCart className="h-5 w-5" />
            <span>CART</span>
            <span
              className="absolute -top-1 -right-1 text-black text-xs font-bold rounded-full h-5 min-w-[1.25rem] px-1 flex items-center justify-center transition-opacity duration-150"
              style={{
                backgroundColor: '#39ff14',
                opacity: cartItemCount > 0 ? 1 : 0,
              }}
              aria-hidden={cartItemCount === 0}
            >
              {cartItemCount > 99 ? '99+' : cartItemCount || '0'}
            </span>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
